const pHeaderIconBaseStyle: React.CSSProperties = {
  width: '24px',
  height: '24px',
  cursor: 'pointer',
};

export default pHeaderIconBaseStyle;
